<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1111 12.5556C15.1111 12.9976 14.9459 13.4216 14.6517 13.7341C14.3575 14.0467 13.9585 14.2223 13.5425 14.2223H2.45754C2.04152 14.2223 1.64253 14.0467 1.34836 13.7341C1.05418 13.4216 0.888916 12.9976 0.888916 12.5556V3.4445C0.888916 3.00247 1.05418 2.57855 1.34836 2.26599C1.64253 1.95343 2.04152 1.77783 2.45754 1.77783H6.37911L7.94774 4.4445H13.5425C13.9585 4.4445 14.3575 4.62009 14.6517 4.93265C14.9459 5.24521 15.1111 5.66914 15.1111 6.11117V12.5556Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
  defineOptions({
    name: 'ProjectsIcon',
  });
</script>
